import { render, staticRenderFns } from "./OnlineCourseListContent.vue?vue&type=template&id=852ee678&scoped=true&"
import script from "./OnlineCourseListContent.vue?vue&type=script&lang=js&"
export * from "./OnlineCourseListContent.vue?vue&type=script&lang=js&"
import style0 from "./OnlineCourseListContent.vue?vue&type=style&index=0&id=852ee678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852ee678",
  null
  
)

export default component.exports